import { useLocation } from "react-router-dom"
import { useState, useEffect,useContext } from "react";
import { HistoryData } from "./History";
import styles from "./HistoryDetail.module.css"
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { baseUrl } from "../../url";
import { AuthContext, AuthContextType } from '../../Auth';

export default function HistoryDetail() {

    const navigate = useNavigate();
    const location = useLocation();
    const Ordered: HistoryData = location.state;
    const order_id = Ordered.order_id;
    type OrderedProduct = {
        productname: string;
        left_right: string;
        size: string;
        color: string;
        cost: number;
        quantity: number;
        receiveDate: string;
    }

    const [historydata, setHistorydata] = useState<HistoryData>();
    const [detail, setDetail] = useState<OrderedProduct[]>([]);
    const [trigger,setTrigger]=useState<boolean>(false);
    const { setAuth } = useContext(AuthContext) as AuthContextType;
    
useEffect(() => {
    const checkAuth = async () => {
            try {
                    const response = await fetch(`${baseUrl}/checkAuth`, {
                    method: "POST",
                    credentials: "include",
                    headers: { 'Content-Type': 'application/json' },
                })
                const data = await response.json();
                if (!data.result) {
                    console.log("Not authenticated");
                   setAuth({ username: null, isAuthenticated: false, office: undefined, authority:"user" });
                   return navigate("/login");
                }
                         const response2 = await fetch(`${baseUrl}/getusersdata`,{
                        method: "POST",
                        credentials: "include",
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ username: data.username })
                    })
                    const data2 = await response2.json();
                    console.log("Authenticated user:", data.username, "Office:", data2.office,"Authority:",data2.authority);
                    setAuth({ username: data.username, isAuthenticated: true, office: data2.office,authority:data2.authority });
                } catch (error) {
                console.error(error);
            }
        }
        checkAuth();
},[navigate, setAuth])

useEffect(()=>{
    const fetchHistory = async () => {
        const response = await fetch(`${baseUrl}/getsinglehistory`,{
            method: "POST",
            credentials: "include",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ order_id: order_id })
        })
        let data = await response.json();
        if(data.isAuth===false){
            alert("セッションが切れました。再度ログインしてください");
            setAuth({ username: null, isAuthenticated: false, office: undefined, authority:"user" });
            return navigate("/login");}
        const orderData = data[0];
        const dayofweek = ["（日）", "（月）", "（火）", "（水）", "（木）", "（金）", "（土）"]; 
        const utcDate = new Date(orderData.order_at);
            const utcReceiveDate = new Date(orderData.receiveDate);
            const convert = (dateItem: Date) => {
                const japanOffset = 9 * 60 * 60 * 1000;
                const japanDate = new Date(dateItem.getTime() + japanOffset);
                const year = japanDate.getFullYear();
                const month = japanDate.getMonth() + 1;
                const date = japanDate.getDate();
                const day = dayofweek[japanDate.getDay()];
                const hours = japanDate.getHours();
                const minutes = japanDate.getMinutes();
                const seconds = japanDate.getSeconds();
                const convertDate = {
                    date: `${year}年${month}月${date}日${day}`,
                    time: `${hours}: ${minutes}: ${seconds}`
                }
                return convertDate;
            }
            const appeardate = convert(utcDate);
                orderData.order_at = appeardate.date + appeardate.time;
            if (orderData.receiveDate) {
                const appearReceivedate = convert(utcReceiveDate);
                orderData.receiveDate = appearReceivedate.date;
            }
        setHistorydata(orderData);
    }

    fetchHistory();

},[trigger,order_id,navigate,setAuth])


    useEffect(() => {
        const fetchdetail = async () => {
            const response = await fetch(`${baseUrl}/gethistorydetail`, {
                method: "POST",
                credentials: "include",
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ order_id: order_id })
            })
            const data = await response.json();
            if(data.isAuth===false){
            alert("セッションが切れました。再度ログインしてください");
            setAuth({ username: null, isAuthenticated: false, office: undefined, authority:"user" });
            return navigate("/login");}
            const dayofweek = ["（日）", "（月）", "（火）", "（水）", "（木）", "（金）", "（土）"];
            const convert = (dateItem: Date) => {
                const japanOffset = 9 * 60 * 60 * 1000;
                const japanDate = new Date(dateItem.getTime() + japanOffset);
                const year = japanDate.getFullYear();
                const month = japanDate.getMonth() + 1;
                const date = japanDate.getDate();
                const day = dayofweek[japanDate.getDay()];
                const hours = japanDate.getHours();
                const minutes = japanDate.getMinutes();
                const seconds = japanDate.getSeconds();
                const convertDate = {
                    date: `${year}年${month}月${date}日${day}`,
                    time: `${hours}: ${minutes}: ${seconds}`
                }
                return convertDate;
            }
            for (let i = 0; data.length > i; i++) {
                if (data[i].receiveDate) {
                    const utcReceiveDate = new Date(data[i].receiveDate);
                    data[i].receiveDate = convert(utcReceiveDate).date
                } else { data[i].receiveDate = "" }
            };
            setDetail(data);
        }
        
        fetchdetail();
        
    }, [trigger,order_id,navigate,setAuth])

    const NavigateHistory = () => {
        navigate("/history");
    }

    const handleEntering = async () => {
        const enteringConfirm = window.confirm("入庫処理をせずに、入庫日のみを登録します。よろしいですか？");
        if (enteringConfirm) {
            try {
                const response = await fetch(`${baseUrl}/submitentering`, {
                    method: "PUT",
                    credentials: "include",
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ order_id: order_id })
                })
                const data = await response.json();
                if(data.isAuth===false){
            alert("セッションが切れました。再度ログインしてください");
            setAuth({ username: null, isAuthenticated: false, office: undefined, authority:"user" });
            return navigate("/login");}
                alert("入庫日を登録しました。")
                setTrigger(!trigger);

            } catch (error) {
                console.error(error);
            }
        } else {
            alert("登録をキャンセルしました。")
        }
    }

    const handleIndividualEntering = async (index: number) => {
        const enteringConfirm = window.confirm("入庫処理をせずに、入庫日登録のみ行います。よろしいですか？");
        if (enteringConfirm) {
            try {
                const response = await fetch(`${baseUrl}/submitindividualentering`, {
                    method: "PUT",
                    credentials: "include",
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        order_id: order_id,
                        productname: detail[index].productname,
                        color: detail[index].color,
                        left_right: detail[index].left_right,
                        size: detail[index].size,
                        quantity: detail[index].quantity
                    })
                })
                const data = await response.json();
                if(data.isAuth===false){
            alert("セッションが切れました。再度ログインしてください");
            setAuth({ username: null, isAuthenticated: false, office: undefined, authority:"user" });
            return navigate("/login");}
                alert("入庫日を登録しました。");
                setTrigger(!trigger);
            } catch (error) {
                console.error(error);
            }
        } else {
            alert("登録をキャンセルしました。")
        }
    }

    const handleDelete = async () => {
        const deleteConfirm = window.confirm("この発注履歴を削除してよろしいですか？");
        if (deleteConfirm) {
            try {
                const response = await fetch(`${baseUrl}/deletehistory`, {
                    method: "DELETE",
                    credentials: "include",
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        order_id: order_id
                    })
                })
                const data = await response.json();
                if(data.isAuth===false){
            alert("セッションが切れました。再度ログインしてください");
            setAuth({ username: null, isAuthenticated: false, office: undefined, authority:"user" });
            return navigate("/login");}
                alert("発注履歴を削除しました。")
                navigate("/history");
            } catch (error) {
                console.error(error);
            }
        } else {
            alert("削除をキャンセルしました。")
        }
    }

    return (
        <div className={styles.div}>
            <h2>発注履歴明細</h2>
            <Button onClick={NavigateHistory}>発注履歴に戻る</Button>
            <div className={styles.scroll}>
                <table className={styles.table}>
                    <thead><tr><th className={styles.th}>発注日時</th><th className={styles.th}>発注元</th><th className={styles.th}>発注者</th><th className={styles.th}>メーカー</th><th className={styles.th}>発注金額</th><th className={styles.th}>入庫日</th></tr></thead>
                    <tbody>
                        {(historydata)?<tr><td className={styles.td}>{historydata.order_at}</td><td className={styles.td}>{historydata.office}</td><td className={styles.td}>{historydata.username}</td><td className={styles.td}>{historydata.supplier}</td><td className={styles.td}>&yen;{historydata.totalprice}</td><td className={styles.td}>{historydata.receiveDate}</td></tr>:null}
                    </tbody>
                </table>
                <table className={styles.table}>
                    <thead><tr><th className={styles.th}>製品名</th><th className={styles.th}>色</th><th className={styles.th}>左右</th><th className={styles.th}>サイズ</th><th className={styles.th}>単価</th><th className={styles.th}>個数</th><th className={styles.th}>入庫日</th></tr></thead>
                    <tbody>
                        {detail ? detail.map((item: OrderedProduct, index: number) => <tr key={index}>
                            <td className={styles.td}>{item.productname}</td><td className={styles.td}>{item.color}</td><td className={styles.td}>{item.left_right}</td><td className={styles.td}>{item.size}</td><td className={styles.td}>&yen;{item.cost}</td><td className={styles.td}>{item.quantity}</td><td className={styles.td}>{item.receiveDate}</td>
                            <td className={styles.td2}>
                                <Button size="small" sx={{ margin: 0 }} onClick={() => handleIndividualEntering(index)} disabled={!(item.receiveDate === "")}>個別に入庫日を登録</Button></td></tr>)
                            : <tr><td>データを取得できません。</td></tr>
                        }
                    </tbody>
                </table>
            </div>
            <Button onClick={handleEntering} disabled={!(Ordered.receiveDate === null)}>入庫日を登録</Button>
            <Button onClick={handleDelete}>履歴を削除する</Button>
        </div>
    )
}